const env = require('/opt/build/repo/twing/environment.js');
let templatesModule = (() => {
let module = {
    exports: undefined
};

module.exports = (TwingTemplate) => {
    return new Map([
        [0, class extends TwingTemplate {
            constructor(env) {
                super(env);

                this.source = this.getSourceContext();
                this.macros = new this.Context();
                let macros = new this.Context();

                this.parent = false;

                this.blocks = new Map([
                ]);
            }

            doDisplay(context, blocks = new Map()) {
                let macros = this.macros.clone();
                this.echo(this.include(context, this.source, this.loadTemplate(`f794e83fe7b49ae56ad5315ec02a75dff67eacff95d1a851043dd7b9fedd1e8a`, `f794e83fe7b49ae56ad5315ec02a75dff67eacff95d1a851043dd7b9fedd1e8a`, 1, 66), new Map([[`heading`, `Progressive Web Apps`], [`href`, `https://cloudfour.com/thinks/progressive-web-apps-book-now-available/`], [`reverse_markup`, true], [`align_start`, true], [`class`, `o-media--1-by-2@l`]]), false, false, 1));
            }

            getTemplateName() {
                return `f794e83fe7b49ae56ad5315ec02a75dff67eacff95d1a851043dd7b9fedd1e8a`;
            }

            isTraitable() {
                return false;
            }

            getSourceContext() {
                return new this.Source(``, `f794e83fe7b49ae56ad5315ec02a75dff67eacff95d1a851043dd7b9fedd1e8a`, ``);
            }
        }],
        [66, class extends TwingTemplate {
            constructor(env) {
                super(env);

                this.source = this.getSourceContext();
                this.macros = new this.Context();
                let macros = new this.Context();

                this.parent = this.loadTemplate(`@cloudfour/components/media-summary/media-summary.twig`, `f794e83fe7b49ae56ad5315ec02a75dff67eacff95d1a851043dd7b9fedd1e8a`, 1);

                this.blocks = new Map([
                    ['object', [this, 'block_object']],
                    ['content', [this, 'block_content']]
                ]);
            }

            doGetParent(context) {
                return `@cloudfour/components/media-summary/media-summary.twig`;
            }

            doDisplay(context, blocks = new Map()) {
                let macros = this.macros.clone();
                this.parent.display(context, this.merge(this.blocks, blocks));
            }

            block_object(context, blocks = new Map()) {
                let macros = this.macros.clone();
                this.echo(`    <img src="/media/bookicon.png" width="730" height="992" alt="" style="width: 7em;">
  `);
            }

            block_content(context, blocks = new Map()) {
                let macros = this.macros.clone();
                this.echo(`    <p>Progressive web apps represent the next big digital opportunity: they look and feel like native apps, they work offline, and they’re available to anyone—no app store required.</p>
  `);
            }

            getTemplateName() {
                return `f794e83fe7b49ae56ad5315ec02a75dff67eacff95d1a851043dd7b9fedd1e8a`;
            }

            isTraitable() {
                return false;
            }

            getSourceContext() {
                return new this.Source(``, `f794e83fe7b49ae56ad5315ec02a75dff67eacff95d1a851043dd7b9fedd1e8a`, ``);
            }
        }],
    ]);
};

    return module.exports;
})();

env.registerTemplatesModule(templatesModule, 'f794e83fe7b49ae56ad5315ec02a75dff67eacff95d1a851043dd7b9fedd1e8a');

let template = env.loadTemplate('f794e83fe7b49ae56ad5315ec02a75dff67eacff95d1a851043dd7b9fedd1e8a');

module.exports = (context = {}) => {
    const rendered = template.render(context);
     const inputs = window.__twig_inputs__ || (window.__twig_inputs__ = new Map());
     inputs.set(
       rendered,
       { path: "@cloudfour/components/media-summary/demo/book.twig", args: context }
     );
     return rendered;;
};